<template>
    <div class="footer py-4">
        <div class="container mt-4">
            <div class="row">
                <div class="col-sm-12 my-3 col-md-4 footer-info">
                    Weg srl<br>
                    P.Iva e cod. Fisc. 02485070359 <br>
                    Codice univoco: subm70n
                </div>
                <div class="col-sm-12 my-3 col-md-5 footer-contacts">
                    <div class="icon icon-phone">
                        <a href="tel:00390599120411">+39 059.9120411</a>
                    </div>
                    <div class="icon icon-pin">
                        <a href="https://goo.gl/maps/bb4xzVi2bBiKAJcD8">Via Campania, 3, 41012 Carpi MO</a>
                    </div>
                    <div class="icon icon-mail">
                        <a href="mailto:info@weg.it">info@weg.it</a>
                    </div>
                </div>
                <div class="col-sm-12 my-3 col-md-3 footer-member">
                    <img src="@/assets/img/member of.png" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'piepagina'
}
</script>

<style scoped lang="scss">
.footer {
    background: black;
    margint-top: 100px;
    @include media-breakpoint-up(md) {
        margin-top: 200px;
    }
}
.footer-info {
    font-size: 14px;
    color: #858585;
}
.footer-contacts {
    > div {
        margin: 15px 0;
    }
    a {
        color: white;
    }
}
.icon {
    &:before {
        content: '';
        display: inline-block;
        margin-rigth: 20px;
    }
}
.icon-mail:before {
    background: transparent url('~/assets/img/icon-mail.svg') no-repeat center center / contain;
}
.icon-phone:before {
    background: transparent url('~/assets/img/icon-phone.svg') no-repeat center center / contain;
}
.icon-pin:before {
    background: transparent url('~/assets/img/icon-pin.svg') no-repeat center center / contain;
}
</style>